import { render, staticRenderFns } from "./time-spinner.vue?vue&type=template&id=0be362e9&"
import script from "./time-spinner.vue?vue&type=script&lang=js&"
export * from "./time-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports